/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resource_Guide_TitleInputs */

const en_blog_resource_guide_title = /** @type {(inputs: Blog_Resource_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the submission guide`)
};

const zh_blog_resource_guide_title = /** @type {(inputs: Blog_Resource_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读提交指南`)
};

/**
* | output |
* | --- |
* | "Read the submission guide" |
*
* @param {Blog_Resource_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resource_guide_title = /** @type {((inputs?: Blog_Resource_Guide_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resource_Guide_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resource_guide_title(inputs)
	return zh_blog_resource_guide_title(inputs)
});
export { blog_resource_guide_title as "blog.resource_guide_title" }